import { RealDataSettings } from 'modules/settingsContainer/common/data/RealDataSettings';
import { DefaultDataSettingsProps } from 'types/global';

export const DefaultDataSettings = ({ dataSettings }: DefaultDataSettingsProps) => (
  <>
    <RealDataSettings value={dataSettings.isRealData} />
  </>
);
